import React, { useContext } from 'react'
import DashboardContext from '../layout/dashboard-context'

const downloadKlassigo = 'https://fastigo.se/wp-content/uploads/2021/09/klassigo_pdf.pdf'
const KlassigoLink = 'https://fastigo.se/klassigo'

interface StatisticsInfoProps {
  alreadySentStatistics: boolean
  showOrganization?: boolean
  showStatus?: boolean
}

const StatisticsInfo: React.FC<StatisticsInfoProps> = ({
  alreadySentStatistics,
  showOrganization = true,
  showStatus = false,
}: StatisticsInfoProps) => {
  const { selectedOrganization } = useContext(DashboardContext)
  return (
    <div>
      <div>
        <div className="flex flex-row justify-start items-start w-full gap-4 flex-wrap">
          <div>
            {showOrganization && <p>{selectedOrganization?.name}</p>}
            <h2>Lämna in lönestatistik</h2>
          </div>
          {showStatus && (
            <div className={alreadySentStatistics ? 'badge submitted' : 'badge not-submitted'}>
              {alreadySentStatistics ? <span> Inlämnad</span> : <span> Ej inlämnad</span>}
            </div>
          )}
        </div>
        <p className="my-2 md:w-2/3 w-full">
          Innan du lämnar in årets statistisk ska du kontrollera att de anställdas klassificering
          enligt Klassigo är uppdaterad och korrekt. Du hittar vägledningen till Klassigo här:{' '}
          <a
            className="text-darkBlue underline font-bold "
            download
            target="_blank"
            rel="noopener noreferrer"
            href={downloadKlassigo}
          >
            Vägledning Klassigo
          </a>{' '}
          samt på{' '}
          <a
            className="text-darkBlue underline font-bold "
            download
            target="_blank"
            rel="noopener noreferrer"
            href={KlassigoLink}
          >
            fastigo.se/klassigo
          </a>
        </p>
      </div>
    </div>
  )
}

export default StatisticsInfo
